/**
 * Constants used in the wr-print-selected-receipt-mustache directive
 */

export const BARCODE_OPTIONS = {
  displayValue: false,
  format: 'CODE128',
  height: 35,
  lineColor: '#000',
  width: 2,
}

export const QRCODE_OPTIONS = {
  errorCorrectionLevel: 'L',
  size: 95,
}

export const CUSTOMER_WALKIN_CODE = 'WALKIN'

export const CUSTOMER_DEFAULTS = {
  CompanyName: '',
  CustomerCode: '',
  Email: '',
  FirstName: '',
  FormattedOnAccountBalance: '$0.00',
  FormattedPostalAddress: '',
  FormattedStoreCredit: '',
  HasCustomerContactDetails: false,
  LastName: '',
  Mobile: '',
  Phone: '',
  LoyaltyBalance: 0.0,
  LoyaltyEnabled: false,
  WalkIn: true,
}

export const GIFT_CARD_SKU = 'vend-internal-gift-card'

export const RECEIPT_DATE_FORMATS = {
  PAYMENT_DATE: 'ddd, D MMM YY h:mma',
  SALE_DATE: 'D MMM YYYY h:mma',
  EXPIRY_DATE: 'ddd, D MMM YY',
}

export const RECEIPT_SETTINGS_HASH_DEFAULTS = {
  LoyaltyQRCode: '',
  Barcode: '',
  IsReprint: false,
  ListItems: [],
  Loyalty: {},
  Note: '',
  DisplayCustomerDetails: true,
  DisplayCustomerBalances: true,
  DisplayCustomerAddress: false,
  DisplayCustomerCompany: false,
  DisplayCustomerEmail: false,
  DisplayCustomerName: false,
  DisplayCustomerPhone: false,
  DisplayLoyaltyBalance: false,
  DisplayLoyaltyEarned: false,
  DisplayLoyaltyLink: false,
  DisplayLoyaltyQRCode: false,
  DisplayLoyaltySection: false,
  DisplayStoreCredit: false,
  DisplayGiftCardInformation: false,
  DisplayCustomerCode: true,
  DisplayProductName: true,
  DisplayProductSKU: false,
  DisplayTaxPerLineItem: false,
}
